import React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';

import { Card, Box, Heading, Text, Button, Col, Row } from 'wix-style-react';
import { ReactComponent as InvoicesSectionSVG } from '../../../../assets/images/invoices-section.svg';

import { datahooks } from '../../../constants';
import { financeSectionCardOptions } from './finances';
import { FinanceOptionCard } from './FinanceOption';
import { CrmHomeBiLogger } from '../../../../bi-logger';

export interface FinancesSectionProps extends InjectedTranslateProps {
  onNavigate(): void;
  biLogger: CrmHomeBiLogger;
}
const FinancesSectionComponent: React.FC<FinancesSectionProps> = (props) => {
  const { t, biLogger } = props;
  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <Card.Content>
              <Box align="space-between">
                <Box direction="vertical">
                  <Heading
                    dataHook={datahooks.homeInvoicesTitle}
                    appearance="H3"
                  >
                    {t('crmHomePage.finances.title')}
                  </Heading>
                  <Box marginTop="12px" marginBottom="24px">
                    <Text
                      dataHook={datahooks.homeInvoicesContent}
                      size="small"
                      secondary
                    >
                      {t('crmHomePage.finances.content')}
                    </Text>
                  </Box>
                  <Box width="168px">
                    <Button
                      dataHook={datahooks.homeInvoicesButton}
                      size="small"
                      onClick={() => props.onNavigate()}
                    >
                      {t('crmHomePage.finances.button')}
                    </Button>
                  </Box>
                </Box>
                <InvoicesSectionSVG />
              </Box>
            </Card.Content>
          </Card>
        </Col>
      </Row>
      <Row>
        {financeSectionCardOptions.map((financeOption) => {
          return (
            <Col span={4} key={financeOption.id}>
              <FinanceOptionCard
                financeId={financeOption.id}
                title={t(`crmHomePage.finances.${financeOption.id}.title`)}
                description={t(
                  `crmHomePage.finances.${financeOption.id}.description`,
                )}
                ctaText={t(`crmHomePage.finances.${financeOption.id}.ctaText`)}
                onActionClicked={() => {
                  biLogger.reportFinancesCardButtonClicked(financeOption.id);
                  financeOption.action();
                }}
              />
            </Col>
          );
        })}
      </Row>
    </React.Fragment>
  );
};

export const FinanceSection = translate()(FinancesSectionComponent);
